export const eegUserDataTokenParam = 'userinfo';
